var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 4.0625H8.9375V2.84375C8.9375 2.19728 8.68069 1.5773 8.22357 1.12018C7.76645 0.663057 7.14647 0.40625 6.5 0.40625C5.85353 0.40625 5.23355 0.663057 4.77643 1.12018C4.31931 1.5773 4.0625 2.19728 4.0625 2.84375V4.0625H2.4375C2.22201 4.0625 2.01535 4.1481 1.86298 4.30048C1.7106 4.45285 1.625 4.65951 1.625 4.875V10.5625C1.625 10.778 1.7106 10.9847 1.86298 11.137C2.01535 11.2894 2.22201 11.375 2.4375 11.375H10.5625C10.778 11.375 10.9847 11.2894 11.137 11.137C11.2894 10.9847 11.375 10.778 11.375 10.5625V4.875C11.375 4.65951 11.2894 4.45285 11.137 4.30048C10.9847 4.1481 10.778 4.0625 10.5625 4.0625ZM4.875 2.84375C4.875 2.41277 5.0462 1.99945 5.35095 1.6947C5.6557 1.38995 6.06902 1.21875 6.5 1.21875C6.93098 1.21875 7.3443 1.38995 7.64905 1.6947C7.95379 1.99945 8.125 2.41277 8.125 2.84375V4.0625H4.875V2.84375ZM10.5625 10.5625H2.4375V4.875H10.5625V10.5625Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e8d2f55452af8747c4e1c7207600e19a.svg";
export { ForwardRef as ReactComponent };